import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import * as directives from "vuetify/lib/directives";

Vue.use(Vuetify);

// Explicitly register the Ripple directive
Vue.directive("ripple", directives.Ripple);

export default new Vuetify({});
